import cx from 'classnames'
import { useBrand } from '../contexts/brand-context'

type HeaderProps = {
  pathname: string
  title?: string
  subTitle?: string
}

export default function Header({
  title,
  subTitle,
  pathname,
}: HeaderProps) {
  const { endUserTheme } = useBrand()
  const logo = endUserTheme?.logoUrl
  const isEcFlowMobilePreview = pathname.includes('ec-flow')

  return (
    <div
      className={cx(
        pathname.includes('campaigns')
          ? 'w-auto bg-cover'
          : 'w-screen bg-cover',
        {

          'pt-4': isEcFlowMobilePreview,
        },
      )}
    >
      <div className="max-w-md w-full m-auto text-center space-y-8 pt-10 pb-6 px-6">
        {logo &&
          <div className="flex items-center justify-center py-4 max-w-md mx-auto">
            <img
              src={logo}
              className="max-h-20 max-w-70 w-auto object-contain"
              alt="Logo"
            />
          </div>
        }
        <h1
          className='text-center !text-3xl leading-none text-slate-50 font-weight-light'
        >
          {title}
        </h1>
        <p
          className="text-xl text-slate-50"
          dangerouslySetInnerHTML={{ __html: subTitle ? subTitle : '' }}
        />
      </div>
    </div>
  )
}
